import { mapObjIndexed, invertObj } from 'ramda';
import { parameterize } from '@moda/portal-stanchions';

export const CATEGORIES = {
  1: 'Accessories',
  2: 'Bags',
  3: 'Beauty',
  4: 'Clothing',
  5: 'Jewelry',
  6: 'Shoes',
  7: 'Vintage',
  8: 'Fine Jewelry',
  10: 'Table Top',
  11: 'Linens',
  12: 'Decor',
  13: 'Technology',
  15: 'Fashion Jewelry'
};

export const CATEGORY_SLUGS = mapObjIndexed(category => parameterize(category), CATEGORIES);

export const CATEGORIES_BY_SLUG = invertObj(CATEGORY_SLUGS);

export type Category = keyof typeof CATEGORIES;
